<template>
  <div class="content-center-wrapper">
    <div class="white-container d-flex align-items-center justify-content-center">
      <div class="col-5">
        <form>
          <div>
            <div class="text-center mb-4">
              <img src="@/assets/img/logos/qqq.png" height="auto" width="150" />
            </div>

            <div class="d-flex align-items-center mb-3">
              <div class="input-material w-100">
                <input
                  type="text"
                  id="Activation Key"
                  name="Activation Key"
                  v-model="auth_key"
                  v-validate="'required'"
                />
                <!-- |alpha_num|min:24|max:24 -->
                <label>Activation Key</label>
              </div>
              <Tooltip :title="`Have you got Brij License? Then please enter the valid key to start with the installation process. Otherwise you can try the trial vesion.`"  />
            </div>
            <p v-if="submitted && errors.has('Activation Key')" class="error_message">
              <!-- {{ item.fieldname }} -->
              {{ errors.first(`${'Activation Key'}`)}}
            </p>
            <div class="pr-4">
              <router-link class="btn-blue-lg w-100" @click.native="onSubmit()" to>Proceed</router-link>
            </div>

            <!-- <p v-if="auth_key == null && submitted" class="error_msg">Please Enter a valid key</p> -->

            <div class="my-3 text-center font-weight-bold">OR</div>

            <div class="d-flex align-items-center">
              <router-link
                @click.native="onClick15DaysTrial()"
                to
                class="btn-blue-lg w-100"
              >15 Days Trial</router-link>
              <Tooltip :title="`Click to try Brij trial version for 15 days.`"  />
              <!-- <input type="submit" value="15 Days Trial" class="btn-blue-lg w-100"> -->
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import SetupService from "@/services/SetupService";
export default {
  metaInfo: {
    title: "perfecasdast",
    titleTemplate: null,
  },
  data() {
    return {
      auth_key: null,
      submitted: false,
    };
  },
  beforeMount() {
    this.getSetupStatus();
  },
  methods: {
    getSetupStatus: function () {
      SetupService.SetupStatus()
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            if (!data.isSetupAllowed) {
              this.$router.push({
                path: data.route,
              });
            }
          } else {
            this.$router.push({
              name: "Error404",
            });
          }
        })
        .catch((err) => {
          this.$router.push({
            name: "Error404",
          });
        });
    },
    onClick15DaysTrial: function () {
      this.$router.replace({
        path: "activation-key",
      });
    },
    onSubmit: function () {
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        if (valid) {
          //  this.submitted = true;
          if (this.auth_key !== null) {
            let payload = {
              auth_key: this.auth_key,
            };
            SetupService.CheckToken(payload)
              .then((response) => {
                const { data } = response;
                if (data && data.status) {
                  this.$router.replace({
                    path: "select-installation-type",
                  });
                  window.localStorage.setItem("AUTH_KEY", this.auth_key);
                } else {
                  this.$toasted.show(data.message);
                }
              })
              .catch((error) => {
                this.$toasted.show(error);
              });
          }
        }
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Installation/welcome.vue